import React, { Component } from 'react'
import { Badge, Modal } from 'antd-mobile'
import get from 'lodash/get'
import array from 'lodash/array'
import injectSheet from 'react-jss'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from '../assets/styles/components/Footer'
import homeIcon from '../assets/icons/navbar/home_brown.svg'
import nextArrowImage from '../assets/images/next-arrow.png'
import DialogComponent from './../containers/hoc/Dialog'
import helpers from 'helpers'
import withToast from './hoc/Toast'
import Toast from './Toast'
import { MERCHANT_RYOU, MERCHANT_616, SOGNO_CAFE, MERCHANT_BAKSO, FIRST_DATA_MERCHANTS } from '../constants/merchant'
import { PAYMENT_GATEWAY_STRIPE, PAYMENT_GATEWAY_FIRST_DATA } from '../constants/app'

import * as _ from 'lodash'
import URLParser from 'helpers/urlParser'
import environment from '../config'
import { loadState } from '../store/localStorage'
import orderApi from 'services/api/order'
import { isMobileOnly } from 'react-device-detect'

const ToastComponent = withToast(Toast)

class FooterComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isRenderToast: false,
      toastMessage: '',
      shouldShowPayDialog: false,
      shouldShowHandUpDialog: false,
      canSubmit: true,
      toastType: 'fail',
      lastRequsetTime: 0,
      paymentType: '',
      selectedPayment: {},
      shouldShowPayment: false,
      shouldShowCreditCard: false,
      totalWithCharge: 0,
      paymentGateway: '',
      recentPaymentInfo: null,
      shouldShowQRC: false,
    }
  }

	shouldShowHandUpLogo = (merchant) => {
	  const excludedMerchants = [MERCHANT_616, MERCHANT_RYOU, SOGNO_CAFE, MERCHANT_BAKSO]
	  if (excludedMerchants.includes(get(merchant, 'id'))) {
	    return false
	  } else {
	    return !merchant.setting.disableHandUp
	  }
	};

	shouldShowConfirmBooking = (merchant) => {
	  const includedMerchants = [MERCHANT_RYOU]
	  return includedMerchants.includes(get(merchant, 'id'))
	};

	componentDidUpdate = async (prevProps, prevState) => {
	  const { merchant, getRecentPaymentInfo } = this.props
	  if (this.props.location.pathname !== prevProps.location.pathname) {
	    // eslint-disable-next-line react/no-did-update-set-state
	    this.setState({ shouldShowPayDialog: false })
	  }

	  // > redner soldout dialog
	  if (
	    !prevProps.soldOut.displaySoldOutDialog.footer &&
			this.props.soldOut.displaySoldOutDialog.footer &&
			this.props.soldOut.soldOutItems
	  ) {
	    this.renderSoldOutDialog()
	  }

	  // payment

	  if (_.get(merchant, 'id') && !this.state.paymentGateway) {
	    let paymentGateway = process.env.REACT_APP_PAYMENT_GATEWAY
	    if (FIRST_DATA_MERCHANTS.includes(this.props.merchant.id)) {
	      paymentGateway = PAYMENT_GATEWAY_FIRST_DATA
	    } else {
	      paymentGateway = PAYMENT_GATEWAY_STRIPE
	    }
	    this.setState({ paymentGateway })

	    try {
	      const recentPaymentInfo = await getRecentPaymentInfo().then((payments) => {
	        return payments.filter((p) => p.gateway === paymentGateway)[0]
	      })
	      this.setState({
	        recentPaymentInfo,
	      })
	    } catch (err) {
	      console.error('CANNOT find any recent payment')
	    }
	  }
	};

	handleCheckout = async () => {
	  const { history } = this.props
	  const path = {
	    pathname: '/basket/checkout',
	    state: { from: history.location.pathname },
	  }
	  history.push(path)
	  console.info('route changed', path)
	};

	handleChangeTable = () => {
	  const { merchant, selectedTable, createBasket } = this.props
	  createBasket({
	    merchantId: merchant.id,
	    table: selectedTable,
	  })
	};

	handleSubmitTakeoutOrder = async () => this.submitOrder(true);

	submitOrder = async (isTakeout, ignoreUnavailable = false) => {
	  const {
	    intl,
	    history,
	    user,
	    merchant,
	    order,
	    resetOrder,
	    resetStash,
	    basket,
	    createBasket,
	    submitBasket,
	  } = this.props

	  const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0

	  try {
	    this.setState({ canSubmit: false })
	    await submitBasket({
	      merchant,
	      promoCode: basket.promoCode,
	      id: basket.id,
	      uuid: basket.uuid,
	      items: order.list, //  orders(array)
	      remark: order.list.remark, // BUG orders(array).remark = undefined
	      isTakeout,
	      ignoreUnavailable,
	    })
	    await resetStash()
	    await resetOrder()
	    history.replace({
	      pathname: '/basket/confirmation',
	      state: { from: history.location.pathname },
	    })
	    this.setState({ canSubmit: true })
	  } catch (err) {
	    console.log('error in Footer', { err })
	    const errKey = (err && err.error) || 'general'
	    const isWaiter =
				merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
	    switch (err && err.error) {
	      case 'some items are not available':
	        // 不用作平常的 error 處理
	        break
	      case 'invalid timeslot':
	        this.setState({
	          isRenderToast: true,
	          toastMessage: intl.formatMessage({ id: 'error.invalid.timeslot' }),
	        })
	        break
	      case 'order not allowed for access':
	        if (isWaiter && basket.table) {
	          await createBasket({
	            merchantId: merchant.id,
	            table: basket.table,
	          })
	          this.submitOrder(false)
	        } else if (!isWaiter) {
	          await this.props.requestCreateBasket({
	            table: basket.table,
	          })
	        }
	        break
	      default:
	        var _msg = intl.formatMessage({ id: `error.${errKey}` }, { ...(err && err.values) })
	        if (_msg === `error.${errKey}`) {
	          _msg = errKey
	        }
	        this.setState({
	          isRenderToast: true,
	          toastMessage: _msg,
	        })
	    }
	  } finally {
	    this.setState({ canSubmit: true })
	  }
	};

	// calculateHistoryQuantity = () => {
	//   const { orderHistory } = this.props
	//   let _optionQty = 0
	//   orderHistory.forEach(historyItem => {
	//     historyItem.items.forEach(optionItem => {
	//       _optionQty += optionItem.quantity
	//     })
	//   })
	//   return _optionQty
	// }

	// calculateHistoryTotal = () => {
	//   const { orderHistory } = this.props
	//   return orderHistory.reduce((accumulator, currentValue) => {
	//     return accumulator + currentValue.total
	//   }, 0)
	// }

	goToHome = () => {
	  const { history } = this.props
	  const path = '/home'
	  history.push(path)
	  console.info('route changed', path)
	};

	goToChangeTable = () => {
	  const { history } = this.props
	  const path = '/basket/change_table'
	  history.push(path)
	};

	goToTakeawaySummary = () => {
	  const { history } = this.props
	  const path = '/basket/takeaway_summary'
	  history.push(path)
	  console.info('route changed', path)
	};

	goToGoogleFormBooking = async () => {
	  window.open(
	    'https://docs.google.com/forms/d/e/1FAIpQLSc45blVVpsdIsKpwIsrt7xUWDlaOkqi7EcwwOJyhHeT9FMllg/viewform',
	  )
	};

	renderCheckoutFooter = () => {
	  const { intl, classes, order, basket, merchant, isTakeaway, resetMenusCache } = this.props
	  const _checkoutConfirmText = intl.formatMessage({ id: 'footer.checkout_confirm' })
	  const _checkoutConfirmBookingText = intl.formatMessage({ id: 'footer.checkout_confirm_booking' })
	  const _checkoutSubmitingText = intl.formatMessage({ id: 'footer.checkout_submiting' })
	  const _totalOfFrontText = intl.formatMessage({ id: 'footer.total_of_front' })
	  const _totalOfFrontTextTakeaway = intl.formatMessage({ id: 'footer.total_of_front.takeaway' })
	  const _totalOfBackText = _.get(merchant, 'setting.hotelMode')
	    ? intl.formatMessage({ id: 'footer.total_of_back2' })
	    : intl.formatMessage({ id: 'footer.total_of_back' })
	  const _totalOfBackTextTakeaway = intl.formatMessage({ id: 'footer.total_of_back.takeaway' })

	  const checkoutFooterConfirmOrderStyle = cx(classes['checkout-footer-confirm-order'])
	  const checkoutFooterConfirmOrderWithClearfixStyle = cx(checkoutFooterConfirmOrderStyle, 'clearfix')
	  const checkoutCheckoutOrderStyle = cx(classes['checkout-checkout-order'])
	  const checkoutTotalOfOrderPrefixTextStyle = cx(classes['checkout-total-order-prefix-text'])
	  const checkoutTotalOfOrderPricePrefixStyle = cx(classes['checkout-total-order-price-prefix'])
	  const checkoutTotalOfOrderTextStyle = cx(classes['checkout-total-order-text'])
	  const checkoutCheckoutOrderTextStyle = cx(classes['checkout-checkout-order-text'])
	  const checkoutTotalOfOrderStyle = cx(classes['checkout-total-order'])

	  const renderSubmitButton = () => {
	    if (this.state.canSubmit) {
	      return (
	        <div
	          className={checkoutCheckoutOrderStyle}
	          style={{ position: 'absolute', right: '0px', top: '0px' }}
	        >
	          {this.shouldShowConfirmBooking(merchant) ? (
	            <div className={checkoutCheckoutOrderTextStyle} onClick={this.goToGoogleFormBooking}>
	              <span>{_checkoutConfirmBookingText}</span>
	            </div>
	          ) : (
	            <div
	              className={checkoutCheckoutOrderTextStyle}
	              onClick={() => {
	                if (isTakeaway) {
	                  this.goToTakeawaySummary()
	                } else {
	                  this.submitOrder()
	                }
	                resetMenusCache()
	              }}
	            >
	              <span>{_checkoutConfirmText}</span>
	            </div>
	          )}
	        </div>
	      )
	    } else {
	      return (
	        <div
	          className={checkoutCheckoutOrderStyle}
	          style={{ position: 'absolute', right: '0px', top: '0px' }}
	        >
	          <div className={checkoutCheckoutOrderTextStyle}>
	            <span>{_checkoutSubmitingText}</span>
	          </div>
	        </div>
	      )
	    }
	  }

	  const renderTotalDivHeader = () => {
	    if (basket.isTakeaway) {
	      return (
	        <div className={checkoutTotalOfOrderPrefixTextStyle} style={{ paddingTop: '10px' }}>
	          <span>{_totalOfFrontTextTakeaway}</span>

	          {order.totalOfDishsFromOrder}

	          <span>{_totalOfBackTextTakeaway}</span>
	        </div>
	      )
	    }
	  }

	  const renderTotalDiv = () => {
	    if (basket.isTakeaway) {
	      return (
	        <div className={checkoutTotalOfOrderTextStyle}>
	          <div className={checkoutTotalOfOrderPricePrefixStyle}>
	            <FontAwesomeIcon icon="dollar-sign" />
	          </div>
	          <div>
	            {' '}
	            {helpers.calculate.calculateOptionsTotal(order) +
								helpers.calculate.calculateDishsTotal(order)}{' '}
	          </div>
	        </div>
	      )
	    } else {
	      return (
	        <div
	          className={checkoutTotalOfOrderTextStyle}
	          style={{ paddingTop: '0px', verticalAlign: 'middle', lineHeight: '60px' }}
	        >
	          {_totalOfFrontText}
	          {order.totalOfDishsFromOrder}
	          {_totalOfBackText}
	        </div>
	      )
	    }
	  }

	  return (
	    <div className={checkoutFooterConfirmOrderWithClearfixStyle}>
	      <div
	        className={checkoutTotalOfOrderStyle}
	        style={{ position: 'absolute', left: 'calc(100%/3)', top: '0px' }}
	      >
	        {renderTotalDivHeader()}
	        {renderTotalDiv()}
	      </div>
	      {renderSubmitButton()}
	    </div>
	  )
	};

	renderFooterLeftSelection = () => {
	  const { intl, classes, user, merchant, basket, isTakeaway } = this.props

	  const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
	  const isFromLanding = window.sessionStorage.getItem('ref') === 'landing'

	  if (isWaiter && !isTakeaway) {
	    const _chooseTableText = intl.formatMessage({ id: 'footer.choose_table' })
	    const commonFooterSelectionStyle = cx(classes['common-footer-selection'])

	    return (
	      <div className={commonFooterSelectionStyle}>
	        <label htmlFor="table-switch" onClick={this.goToChangeTable}>
	          <span className={cx(classes['choose-table-text'])}>{_chooseTableText}</span>
	          <span>{basket.table}</span>
	        </label>
	      </div>
	    )
	  }

	  let commonFooterLogo
	  let commonFooterLogoStyle
	  const handleHandUp = () => this.setState({ shouldShowHandUpDialog: true })

	  if (isTakeaway || !basket.table) {
	    // empty for takeaway footer
	    commonFooterLogoStyle = cx(classes['common-footer-logo-hidden'])
	    commonFooterLogo = <div className={commonFooterLogoStyle} />
	    if (isFromLanding) {
	      commonFooterLogoStyle = cx(classes['common-footer-logo-hidden'], classes['common-footer-logo-home'])
	      commonFooterLogo = (
	        <div
	          className={commonFooterLogoStyle}
	          onClick={() => {
	            window.location.href = environment.landingUrl
	          }}
	        >
	          <img style={{ marginRight: 8 }} src={homeIcon} alt="home" />
	          {intl.formatMessage({ id: 'footer.other_restaurants' })}
	        </div>
	      )
	    }
	  } else {
	    if (basket.paying) {
	      const waitingForPaymentText = intl.formatMessage({ id: 'footer.waiting_for_payment' })
	      commonFooterLogoStyle = cx(classes['common-footer-logo-hidden'])
	      commonFooterLogo = <div className={commonFooterLogoStyle}>{waitingForPaymentText}</div>
	    } else {
	      if (merchant && (merchant.setting.waiter || basket.canPay) && this.shouldShowHandUpLogo(merchant)) {
	        commonFooterLogoStyle = cx(classes['common-footer-logo'])
	        commonFooterLogo = <div className={commonFooterLogoStyle} onClick={handleHandUp} />
	      } else {
	        commonFooterLogoStyle = cx(classes['common-footer-logo-hidden'])
	        commonFooterLogo = <div className={commonFooterLogoStyle} />
	      }
	    }
	  }

	  return commonFooterLogo
	};

	renderStepButtonLabel = (currentStep, nextStep, nextStepIndex, setItem, firstStep) => {
	  const { intl, classes, history } = this.props

	  const _noOfText = intl.formatMessage({ id: 'footer.no_of' })
	  const _stepText = intl.formatMessage({ id: 'footer.step' })
	  const buttonLabelPrefix = intl.formatMessage({ id: 'footer.remaining_prefix' })
	  const buttonLabelSuffix = intl.formatMessage({ id: 'footer.remaining_suffix' })
	  const commonFooterPackageButtonTextStyle = cx(classes['common-footer-package-button-text'])
	  const nextStepMin = nextStep && nextStep.min
	  const firstStepQty = firstStep && firstStep.quantity
	  const stepMin = nextStep.overrideMinMax ? firstStepQty * nextStep.overrideMinMax : nextStepMin
	  const currentStepMin = currentStep && currentStep.min
	  const currentStepQty = currentStep ? currentStep.quantity : 0

	  let buttonLabel = ''
	  if (currentStepMin === 0 || (currentStepMin !== 0 && currentStepQty >= currentStepMin)) {
	    buttonLabel = `${_noOfText} ${nextStepIndex + 1} ${_stepText}`
	  } else {
	    const currentStepKey = history.location.pathname.split('/').pop()
	    const currentStepIndex = array.findIndex(setItem.steps, (step) => step.key === currentStepKey)
	    const currentStep = setItem.steps[currentStepIndex]

	    if (currentStepIndex !== -1) {
	      if (currentStep.quantity >= currentStepMin) {
	        buttonLabel = `${_noOfText} ${nextStepIndex + 1} ${_stepText}`
	      } else {
	        buttonLabel = `${buttonLabelPrefix}${currentStepMin - currentStepQty}${buttonLabelSuffix}`
	      }
	    } else {
	      buttonLabel = `${buttonLabelPrefix}${currentStepMin - currentStepQty}${buttonLabelSuffix}`
	    }
	  }

	  return <div className={commonFooterPackageButtonTextStyle}>{buttonLabel}</div>
	};

	renderOrderFooter = (params) => {
	  // if found next item for next step
	  // remaining steps to complete
	  const { intl, classes, history, user, updateSetOrderConfirmedStatus, merchant, resetStash, resetStashByOptionGroups, resetStashByRadioGroups } = this.props

	  const {
	    setItem,
	    currentStep,
	    nextStep,
	    nextStepIndex,
	    // optional,
	    // isFinalStep,
	    firstStep,
	  } = params

	  const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
	  const path = `/category/set/${setItem.dishId}/${nextStep.key}`

	  // Auto next step.
	  // TODO 自動跳下一個 step 後可以回來改 （現在會卡在下一步）
	  if (currentStep) {
	    const { quantity, autoNextStep } = currentStep
	    const stepMax = currentStep.overrideMinMax
	      ? firstStep.quantity * currentStep.overrideMinMax
	      : currentStep.max
	    const stepFulfilled = stepMax ? quantity === stepMax : quantity === 1
	    if (!isWaiter && autoNextStep && stepFulfilled) {
	      history.push(path)
	      resetStash()
	      resetStashByOptionGroups()
	      resetStashByRadioGroups()
	      console.info('route changed', path)
	    }
	  }

	  const _choosingText = intl.formatMessage({ id: 'footer.choosing' })
	  const _setNoText = intl.formatMessage({ id: 'footer.set_no' })
	  const _stillNotChooseFrontText = intl.formatMessage({ id: 'footer.still_not_choose_front' })
	  const _stillNotChooseBackText = intl.formatMessage({ id: 'footer.still_not_choose_back' })
	  const _skipAllText = intl.formatMessage({ id: 'footer.skipAll' })

	  const commonFooterPackageLeftStyle = cx(classes['common-footer-package-left'])
	  const commonFooterPackageRightStyle = cx(classes['common-footer-package-right'])
	  const commonFooterPackageChoosingTextStyle = cx(classes['common-footer-package-choosing-text'])
	  const commonFooterPackageDishStyle = cx(classes['common-footer-package-dish'])
	  const commonFooterPackageBadgeWrapStyle = cx(classes['common-footer-package-badge-wrap'])
	  const commonFooterPackageButtonStyle = cx(classes['common-footer-package-button'])
	  const commonFooterPackageButtonIconStyle = cx(classes['common-footer-package-button-icon'])
	  const commonFooterOrderWrapStyle = cx(classes['common-footer-order-setItem-wrap'])
	  const commonTotalOfOrderNumberStyle = cx(classes['common-total-order-number'])
	  const commonFooterSkipTextStyle = cx(classes['common-footer-skip-text'])
    	const commonFooterSkipWrapStyle = cx(classes['common-footer-skip-wrap'])

	  // const commonCheckoutOrderStyle = cx(classes['common-checkout-order'])
	  // const commonCheckoutOrderTextStyle = cx(classes['common-checkout-order-text'], classes['common-checkout-order-text-small'])

	  return (
	    <div>
	      {
	        isWaiter &&
				<div className={commonFooterSkipWrapStyle}
				  onClick={async () => {
				    const catId = history.location.pathname.split('/')[3]
				    await updateSetOrderConfirmedStatus({ catId: catId, confirmed: true })
				  }}>
				  <div className={commonFooterSkipTextStyle}>{_skipAllText}</div>
				</div>
			  }
	      <div className={commonFooterOrderWrapStyle}>
	        <div className={commonFooterPackageLeftStyle}>
	          <div className={commonFooterPackageChoosingTextStyle}>{_choosingText}</div>
	          <div>
	            <span className={commonTotalOfOrderNumberStyle}>{setItem.quantity}</span>
	            <span>{_setNoText}</span>
	            <span className={commonFooterPackageDishStyle}>{setItem.dish}</span>
	          </div>
	          <div className={commonFooterPackageBadgeWrapStyle}>
	            <Badge text={`${_stillNotChooseFrontText} ${nextStep.name} ${_stillNotChooseBackText}`} hot />
	          </div>
	        </div>

	        <div className={commonFooterPackageRightStyle}>
	          <div
	            className={commonFooterPackageButtonStyle}
	            onClick={() => {
	              history.push(path)
	              console.info('route changed', path)
	            }}
	          >
	            <div className={commonFooterPackageButtonIconStyle}>
	              <img src={nextArrowImage} alt="" />
	            </div>

	            {this.renderStepButtonLabel(currentStep, nextStep, nextStepIndex, setItem, firstStep)}
	          </div>
	        </div>
	      </div>
	    </div>
	  )
	};

	renderStandbyFooter = () => {
	  const { intl, classes, order, basket, isTakeaway, merchant } = this.props

	  const _checkoutText = intl.formatMessage({ id: 'footer.checkout' })
	  const _checkoutImmediateText = intl.formatMessage({ id: 'footer.checkout_immediate' })
	  const _dishNoText = _.get(merchant, 'setting.hotelMode')
	    ? intl.formatMessage({ id: 'footer.item_no' })
	    : intl.formatMessage({ id: 'footer.dish_no' })
	  let _tableNoText = ''

	  if (isTakeaway) {
	    _tableNoText = intl.formatMessage({ id: 'footer.takeaway_no' }, { value: basket.table })
	  } else if (_.get(merchant, 'setting.hotelMode')) {
	    _tableNoText = intl.formatMessage({ id: 'footer.room_no' }, { value: basket.table })
	  } else {
	    _tableNoText = basket.table
	      ? intl.formatMessage({ id: 'footer.table_no' }, { value: basket.table })
	      : intl.formatMessage({ id: 'footer.waiting_for_table' })
	  }

	  const commonFooterOrderWrapStyle = cx(classes['common-footer-order-wrap'])
	  const commonCheckoutOrderTextStyle = cx(classes['common-checkout-order-text'])
	  const commonTotalOfOrderNumberStyle = cx(classes['common-total-order-number'])
	  const commonTotalOfOrderStyle = cx(classes['common-total-order'], {
	    [classes['common-total-order-preorder']]: !basket.table && !isTakeaway,
	  })
	  const commonTotalOfOrderTextStyle = cx(classes['common-total-order-text'])
	  const commonTotalOfOrderPrefixTextStyle = cx(classes['common-total-order-prefix-text'])
	  const commonFooterConfirmOrderStyle = cx(classes['common-footer-confirm-order'])
	  const commonFooterConfirmOrderWithClearfixStyle = cx(commonFooterConfirmOrderStyle, 'clearfix')

	  let commonCheckoutOrderText = ''
	  let commonCheckoutOrderStyle = ''
	  if (
	    (basket.table && (order.totalOfDishsFromOrder === 0 || basket.paying)) || // 內用時未點餐
			!basket.id
	  ) {
	    commonCheckoutOrderStyle = cx(classes['common-checkout-order'], classes['common-checkout-order-disable'])
	    commonCheckoutOrderText = <span>{_checkoutImmediateText}</span>
	  } else {
	    commonCheckoutOrderStyle = cx(classes['common-checkout-order'], {
	      [classes['common-checkout-order-preorder']]: !basket.table && !isTakeaway,
	    })
	    commonCheckoutOrderText = <span>{_checkoutText}</span>
	  }

	  const renderBadge = () => {
	    if (order.totalOfDishsFromOrder && !basket.paying) {
	      return <div className="badge">{order.totalOfDishsFromOrder}</div>
	    }
	  }

	  return (
	    <React.Fragment>
	      <div className={commonFooterOrderWrapStyle}>
	        {/* footer left */}
	        {this.renderFooterLeftSelection()}
	        {/* footer right */}
	        <div className={commonFooterConfirmOrderWithClearfixStyle}>
	          <div className={commonTotalOfOrderStyle}>
	            <div className={commonTotalOfOrderPrefixTextStyle}>{_tableNoText}</div>
	            <div className={commonTotalOfOrderTextStyle}>
	              <span className={commonTotalOfOrderNumberStyle}>{order.totalOfDishsFromOrder}</span>
	              <span>{_dishNoText}</span>
	            </div>
	          </div>

	          {(isTakeaway || basket.table) && (
	            <div className={commonCheckoutOrderStyle} onClick={this.handleCheckout}>
	              {renderBadge()}
	              <div className={commonCheckoutOrderTextStyle}>{commonCheckoutOrderText}</div>
	            </div>
	          )}
	        </div>
	      </div>
	      {this.renderPaymentsDialog()}
	      {this.renderHandUpDialog()}
	    </React.Fragment>
	  )
	};

	renderFinishOrderFooter = () => {
	  // if found next item for next step
	  // remaining steps to complete
	  const { intl, classes, history, updateSetOrderConfirmedStatus } = this.props
	  // const path = `/category/set/${setItem.dishId}/${setStep.key}`

	  const _footerConfirmText = intl.formatMessage({ id: 'footer.confirm' })
	  // const _choosingText = intl.formatMessage({ id: 'footer.choosing' })
	  // const _setNoText = intl.formatMessage({ id: 'footer.set_no' })
	  // const _stillNotChooseFrontText = intl.formatMessage({ id: 'footer.still_not_choose_front' })
	  // const _stillNotChooseBackText = intl.formatMessage({ id: 'footer.still_not_choose_back' })

	  const commonFooterPackageLeftStyle = cx(classes['common-footer-package-left'])
	  const commonFooterPackageRightStyle = cx(classes['common-footer-package-right'])
	  const commonFooterPackageChoosingTextStyle = cx(classes['common-footer-package-choosing-text'])
	  const commonFooterPackageBadgeWrapStyle = cx(classes['common-footer-package-badge-wrap'])
	  const commonFooterPackageButtonStyle = cx(classes['common-footer-package-button'])
	  const commonFooterOrderWrapStyle = cx(classes['common-footer-order-setItem-wrap'])
	  // const commonFooterPackageDishStyle = cx(classes['common-footer-package-dish'])
	  // const commonCheckoutOrderStyle = cx(classes['common-checkout-order'])
	  // const commonCheckoutOrderTextStyle = cx(classes['common-checkout-order-text'], classes['common-checkout-order-text-small'])
	  // const commonTotalOfOrderNumberStyle = cx(classes['common-total-order-number'])

	  return (
	    <div className={commonFooterOrderWrapStyle}>
	      <div className={commonFooterPackageLeftStyle}>
	        <div className={commonFooterPackageChoosingTextStyle}>{/* { _choosingText } */}</div>
	        <div>
	          {/* <span className={ commonTotalOfOrderNumberStyle }>{ setItem.quantity }</span> */}
	          {/* <span>{ _setNoText }</span> */}
	          {/* <span className={ commonFooterPackageDishStyle }>{ setItem.dish }</span> */}
	        </div>
	        <div className={commonFooterPackageBadgeWrapStyle}>
	          {/* <Badge text={ `${_stillNotChooseFrontText}  ${_stillNotChooseBackText}` } hot /> */}
	        </div>
	      </div>

	      <div
	        className={commonFooterPackageRightStyle}
	        onClick={async () => {
	          const catId = history.location.pathname.split('/')[3]
	          await updateSetOrderConfirmedStatus({ catId: catId, confirmed: true })
	        }}
	      >
	        <div className={commonFooterPackageButtonStyle}>{_footerConfirmText}</div>
	      </div>
	    </div>
	  )
	};

	renderFooter = () => {
	  const { order, currentStepIndex } = this.props
	  const orders = order.list

	  let setItem, currentStep, nextStep, nextStepIndex, optional, isFinalStep, firstStep
	  let isFinishOrder = false
	  orders.some((order) => {
	    if (order.steps && !order.confirmed) {
	      currentStep = order.steps[currentStepIndex]
	      firstStep = order.steps[0]

	      const steps = order.steps.filter((step) => {
	        if (step.dependsOnSetMenuItem || (step.dependsOnSetMenuItems && step.dependsOnSetMenuItems.length > 0)) {
				    let nextStep = _.get(order, 'items', []).map((i) => i.dishId).includes(step.dependsOnSetMenuItem)
	          _.get(order, 'items', []).map((i) => i.dishId).some(o => {
	            if (step.dependsOnSetMenuItems && step.dependsOnSetMenuItems.includes(o)) {
	              nextStep = true
	              return true
	            }
	          })
	          return nextStep
	        }
	        return true
	      })

	      // > 找未完成的 step，從第一個 step 開始往後，包含 currentStep 本身
	      // find next unfulfilled step including currentStep
	      nextStepIndex = steps.findIndex((step, index) => {
	        // > step.optional === true, 會多一個 "不需要" 選項
	        if (step.optional) {
	          return index > currentStepIndex
	          // true: if this step is optional and is more steps
	          // false: do not fulfill optional step that is previous the current step
	        }

	        // > 使用第一步的 min
	        if (step.overrideMinMax) {
	          // > step.min === 0, Stepper 是 Radio
	          if (firstStep.min <= 0 && step.quantity === 1) {
	            // if step has been fulfilled
	            return false
	          }

	          // > 確認目前步驟數量是否與 firstStep.quantity * step.overrideMinMax 相等
	          if (step.quantity !== 0) {
	            // check if fulfilled min req.
	            let multiplier = 1
	            if (typeof step.overrideMinMax === 'number') {
	              multiplier = step.overrideMinMax
	            }
	            return step.quantity !== firstStep.quantity * multiplier
	          }
	        }

	        // > step.min === 0, Stepper 是 Radio
	        if (step.min <= 0 && step.quantity === 1) {
	          // if step has been fulfilled
	          return false
	        }

	        // > 確認數量是否大於最小必須值
	        if (step.quantity !== 0) {
	          // check if fulfilled min req.
	          return step.quantity < step.min
	        }

	        return true
	      })

	      isFinalStep = nextStepIndex === steps.length - 1

	      if (steps[currentStepIndex] !== undefined) {
	        optional = steps[currentStepIndex].optional
	      }

	      if (nextStepIndex !== -1) {
	        // > 若有未完成的 step （有找到 nextStepIndex）
	        setItem = order
	        nextStep = steps[nextStepIndex]
	        return true
	      } else {
	        // > 若所有 step 都完成 （找不到 nextStepIndex）
	        isFinishOrder = true
	      }
	    }
	    return false
	  })

	  if (setItem) {
	    // render order footer if there is next step required in the current menu
	    return this.renderOrderFooter({
	      setItem,
	      currentStep,
	      nextStep,
	      nextStepIndex,
	      optional,
	      isFinalStep,
	      firstStep,
	    })
	  } else if (isFinishOrder) {
	    return this.renderFinishOrderFooter()
	  } else {
	    return this.renderStandbyFooter()
	  }
	};

	renderChangeTableFooter = () => {
	  const { intl, classes, basket, selectedTable } = this.props
	  const isCurrentTable = selectedTable === basket.table
	  const _footText = intl.formatMessage({ id: 'footer.confirm' })
	  const commonFooterOrderWrapStyle = cx(classes['common-footer-order-wrap'])
	  const validChangeTableButtonStyle = cx(classes['change-table-button'])
	  // const invalidChangeTableButtonStyle = cx(classes['change-table-button-invalid'])
	  // const changeTableButtonStyle = isCurrentTable ? invalidChangeTableButtonStyle : validChangeTableButtonStyle

	  return (
	    <div className={commonFooterOrderWrapStyle}>
	      <div
	        className={validChangeTableButtonStyle}
	        onClick={() => {
	          if (!isCurrentTable) {
	            this.handleChangeTable()
	          }
	          this.goToHome()
	        }}
	      >
	        {_footText}
	      </div>
	    </div>
	  )
	};

	renderSoldOutDialog = () => {
	  const { intl, soldOut, orders } = this.props
	  const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })
	  const continueButtonText = intl.formatMessage({ id: 'dialog.continue_btn' })
	  const soldOutText = intl.formatMessage({ id: 'dialog.sold_out_title' })
	  const allSoldOutText = intl.formatMessage({ id: 'dialog.all_sold_out_title' })

	  // > 當所選商品皆已售完。
	  const isAllSelectedItemsSoldOut = !soldOut.soldOutCanContinue

	  // > 當所選商品皆已售完，顯示不同的 title。
	  const title = (
	    <p style={{ lineHeight: 1.5, margin: 0 }}>{isAllSelectedItemsSoldOut ? allSoldOutText : soldOutText}</p>
	  )

	  // message
	  const soldOutItems = _(soldOut.soldOutItems)
	    .groupBy((o) => [o.menuID, o.setMenuID, o.setMenuIndex].join('|')) // {uid:[]item}
	    .map((items, i) => {
	      const item = items[0]
	      let _text = item.name
	      if (item.setMenuID) {
	        const setName = orders.filter((o) => {
	          return _.find(o.items, { dishId: item.setMenuID })
	        })[0].dish
	        _text = setName + ' ' + item.name
	      }

	      // _text += (' (剩' + soldOut.soldOutInventory[item.menuID] + '個)')
	      return (
	        <li key={i} style={{ textAlign: 'left' }}>
	          {_text}
	        </li>
	      )
	    })
	    .value()

	  const message = soldOutItems

	  // buttons
	  const goBackButton = {
	    text: goBackButtonText,
	    onPress: () => {
	      this.props.updateDisplaySoldOutDialogFooter(false)
	      this.props.updateSoldOutItems(null)
	    },
	  }
	  const continueButton = {
	    text: continueButtonText,
	    onPress: () => {
	      this.props.updateDisplaySoldOutDialogFooter(false)
	      this.props.updateSoldOutItems(null)
	      this.submitOrder(false, true) // > (isTakeout, ignoreUnavailable)
	    },
	  }
	  // > 當所選商品皆已售完，dialogButton 只有返回沒有繼續
	  const dialogButtons = isAllSelectedItemsSoldOut ? [goBackButton] : [goBackButton, continueButton]

	  Modal.alert(title, message, dialogButtons)
	};

	renderPaymentsDialog = () => {
	  const { intl, merchant, basket, payBasket, orders, classes, stripe } = this.props
	  const { totalWithCharge, paymentType, shouldShowPayment, shouldShowCreditCard, shouldShowQRC } = this.state
	  // show payment list from merchant payments,and mapping payment name from default payments
	  const payments = _.get(merchant, 'payments')
	  let filteredPayemt
	  if (_.get(payments, 'length')) {
	    filteredPayemt = payments.filter(p => {
	      if (p.key === 'visa' || p.key === 'master' || p.key === 'ae') {
	        if (merchant.setting.enableDineInCreditCardPayment) {
	          return p
	        }
	      } else {
	        return p
	      }
	    })
	  }
	  const _paymentList = [
	    intl.formatMessage({ id: 'checkout.method.cash' }),
	  ]
	  if (_.get(merchant, 'setting.enableDineInCreditCardPayment')) {
	    _paymentList.push(intl.formatMessage({ id: 'checkout.method.card' }))
	  }

	  const getCurrentOrder = async () => {
	    const { basket: { id }, orderHistory } = this.props
	    const currentOrderKey = _.findKey(orderHistory, { id: id })
	    let currentOrder = []
	    if (typeof currentOrderKey !== 'undefined') {
	      currentOrder = orderHistory[currentOrderKey]
	    } else {
	      currentOrder = await orderApi.getOrder(id)
	    }
	    return currentOrder
	  }

	  const payWithMethod = async (method) => {
	    // first get payment type from merchant payments, if none, then get from default payment mapping
	    const _visa = intl.formatMessage({ id: 'checkout.method.visa' })
	    const _master = intl.formatMessage({ id: 'checkout.method.master' })
	    const _ae = intl.formatMessage({ id: 'checkout.method.ae' })
	    const _alipay = intl.formatMessage({ id: 'checkout.method.alipay' })
	    const _wechat = intl.formatMessage({ id: 'checkout.method.wechat' })
	    const _octopus = intl.formatMessage({ id: 'checkout.method.octopus' })
	    const _cash = intl.formatMessage({ id: 'checkout.method.cash' })

	    const payments = [
	      {
	        key: 'cash',
	        name: '',
	        serviceCharge: { percent: 0, amount: 0 },
	        tips: false,
	      },
	      {
	        key: 'card',
	        name: '',
	        serviceCharge: { percent: 0, amount: 0 },
	        tips: false,
	      },
	    ]
	    const payment = payments.find(
	      (p) => (p.name || intl.formatMessage({ id: 'checkout.method.' + p.key })) === method,
	    )
	    const type = payment ? payment.key : ''
	    const order = await getCurrentOrder()
	    this.setState({
	      totalWithCharge:
					order.total + order.total * (payment.serviceCharge.percent / 100) + payment.serviceCharge.amount,
	      paymentType: type || method,
	      shouldShowPayment: true,
	      shouldShowPayDialog: false,
	    })
	    // if (type === '') {
	    //   this.setState({paymentType:method})
	    //   switch (method) {
	    //     case _visa:
	    //       type = 'visa'
	    //       return
	    //     case _master:
	    //       type = 'master'
	    //       return
	    //     case _ae:
	    //       type = 'ae'
	    //       return
	    //     case _alipay:
	    //       type = 'alipay'
	    //       return
	    //     case _wechat:
	    //       type = 'wechat'
	    //       return
	    //     case _octopus:
	    //       type = 'octopus'
	    //       return
	    //     case _cash:
	    //       type = 'cash'
	    //       return
	    //     default:
	    //       break
	    //   }
	    // }

	    // payBasket({ id: basket.id, paymentMethod: type });
	  }

	  const handlePayment = async (_paymentType) => {
	    const token = loadState().user.token
	    switch (_paymentType) {
	    //   case 'wechat':
	    //     const { state, wc_payload } = await this.props.makeWechatPayment({
	    //       isMobile: isMobileOnly,
	    //       deliveryType: 'wechat',
	    //       basket,
	    //       merchant,
	    //       orders,
	    //       amount: totalWithCharge,
	    //     })

	    //     const localStorageToServer = {
	    //       state: loadState(),
	    //       wc_payload,
	    //     }
	    //     if (isMobileOnly) {
	    //       await orderApi.saveCache(state.outTradeNo, localStorageToServer, token).then((res) => {
	    //         setTimeout(() => {
	    //           window.location.replace(
	    //             state.payUrl +
	      // 								'&redirect_url=' +
	      // 								encodeURIComponent(
	      // 									`${window.location.protocol}//${window.location
	      // 										.hostname}/wechatpay_confirmation?cid=${state.outTradeNo}&isDineIn=true`,
	      // 								),
	    //           )
	    //         })
	    //       })
	    //     } else {
	    //       this.setState({
	    //         shouldShowPayment: false,
	    //         shouldShowQRC: true,
	    //         wc_qrcode: state.qrcode,
	    //         syssn: state.syssn,
	    //         outTradeNo: state.outTradeNo,
	    //       })
	    //     }

	    //     break
	      case 'card':
	        this.setState({ shouldShowCreditCard: true, shouldShowPayment: false })
	        break
	      default:
	        payBasket({ id: basket.id, paymentMethod: _paymentType })
	        const _msg = intl.formatMessage({ id: 'checkout.waiting.pay.toast' })
	        this.setState(
	          {
	            isRenderToast: true,
	            toastMessage: _msg,
	            toastType: 'normal',
	          },
	          () => {
	            this.setState({ isRenderToast: false, shouldShowPayment: false })
	          },
	        )
	        break
	    }
	  }
	  const submitDineinPayment = async ({
	    payment,
	    source,
	    gateway,
	    payload,
	    syssn,
	  }) => {
	    const {
	      basket: { id },
	      history,
	    } = this.props
	    try {
	      const result = await this.props.submitDineinPayment(id, {
	        payment: {
	          paymentMethod: payment,
	          gateway,
	          payload,
	        },
	        out_trade_no: source,
	        source,
	        syssn,
	      })
	      if (result.status === 'paid') {
	        history.push('/basket/checkout_complete')
	      }
	    } catch (err) {
	      console.log('submitDineinPayment error', err)
	    }
	  }
	  if (shouldShowPayment) {
	    handlePayment(paymentType)
	  }
	  if (shouldShowQRC) {
	    const weChatPayPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.wechatPay' })
	    const weChatPayStyle = cx(classes['payment-option-wechatpay'])
	    const paymentOptionStyle = cx(classes['payment-option'])

	    const optionHeading = (
	      <div className={paymentOptionStyle}>
	        <div title={weChatPayPaymentText} className={weChatPayStyle} />
	      </div>
	    )
	    return (
	      <DialogComponent
	        optionHeading={optionHeading}
	        triggerModal={payWithMethod}
	        paymentGateway={this.state.paymentGateway}
	        amount={totalWithCharge}
	        dialogType="qrc"
	        onClose={() => this.setState({ shouldShowQRC: false })}
	        isOpen
	        submit={submitDineinPayment}
	        syssn={this.state.syssn}
	        qrcode={this.state.wc_qrcode}
	        outTradeNo={this.state.outTradeNo}
	      />
	    )
	  }
	  if (shouldShowCreditCard) {
	    const creditCardPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.creditCard' })
	    const creditCardStyle = cx(classes['payment-option-credit-card'])
	    const paymentOptionStyle = cx(classes['payment-option'])
	    const optionHeading = (
	      <div className={paymentOptionStyle}>
	        <div title={creditCardPaymentText} className={creditCardStyle} />
	      </div>
	    )

	    return (
	      <DialogComponent
	        optionHeading={optionHeading}
	        triggerModal={payWithMethod}
	        paymentGateway={this.state.paymentGateway}
	        amount={totalWithCharge}
	        dialogType="creditcard"
	        onClose={() => this.setState({ shouldShowCreditCard: false })}
	        isOpen
	        submit={submitDineinPayment}
	        stripe={stripe}
	      />
	    )
	  }
	  if (this.state.shouldShowPayDialog && !basket.paying) {
	    return (
	      <DialogComponent
	        triggerModal={payWithMethod}
	        dialogType="operation"
	        list={_paymentList}
	        onClose={() => this.setState({ shouldShowPayDialog: false })}
	      />
	    )
	  }
	};

	renderHandUpDialog = () => {
	  const { intl, basket, merchant, requestService } = this.props

	  const _handUpList = []
	  if (basket.canPay) {
	    _handUpList.push(intl.formatMessage({ id: 'checkout.hand.up.pay' }))
	  }
	  if (merchant && merchant.setting.waiter) {
	    _handUpList.push(intl.formatMessage({ id: 'checkout.hand.up.waiter' }))
	  }

	  const payOrder = () => this.setState({ shouldShowPayDialog: true })
	  const handUpWithOption = (method) => {
	    this.setState({ shouldShowHandUpDialog: false })
	    let _msg
	    if (method === intl.formatMessage({ id: 'checkout.hand.up.waiter' })) {
	      _msg = intl.formatMessage({ id: 'checkout.waiting.waiter.toast' })
	      // show toast
	      this.setState(
	        {
	          isRenderToast: true,
	          toastMessage: _msg,
	          toastType: 'normal',
	        },
	        () => {
	          this.setState({ isRenderToast: false })
	        },
	      )
	      // send api request only if last request was longer than 1 min
	      if (new Date().getTime() - this.state.lastRequsetTime > 60 * 1000) {
	        this.setState({
	          lastRequsetTime: new Date().getTime(),
	        })
	        requestService({ id: basket.id })
	      }
	    } else if (method === intl.formatMessage({ id: 'checkout.hand.up.pay' })) {
	      _msg = intl.formatMessage({ id: 'checkout.waiting.pay.toast' })
	      // this.setState({
	      //   isRenderToast: true,
	      //   toastMessage: _msg,
	      //   toastType: 'normal',
	      // }, () => {
	      //   this.setState({ isRenderToast: false })
	      // })
	      payOrder()
	    }
	  }

	  if (this.state.shouldShowHandUpDialog) {
	    return (
	      <DialogComponent
	        triggerModal={handUpWithOption}
	        dialogType="operation"
	        list={_handUpList}
	        onClose={() => this.setState({ shouldShowHandUpDialog: false })}
	      />
	    )
	  }
	};

	renderToast = () => {
	  if (this.state.isRenderToast) {
	    return (
	      <ToastComponent
	        toastType={this.state.toastType}
	        duration={5}
	        message={this.state.toastMessage}
	        callback={this.resetToast}
	      />
	    )
	  }
	};

	resetToast = () => {
	  this.setState({
	    isRenderToast: false,
	    toastMessage: '',
	  })
	};

	render = () => {
	  const { classes, history, order } = this.props

	  const path = history.location.pathname
	  const checkoutFooterWrapStyle = cx(classes.wrap, classes['checkout-footer'])
	  const commonFooterWrapStyle = cx(classes.wrap, classes['common-footer'])
	  switch (path) {
	    case '/basket/confirmation':
	      return <div />
	    case '/basket/change_table':
	      return <div />

	    case '/basket/change_table/table':
	      return <div className={commonFooterWrapStyle}>{this.renderChangeTableFooter()}</div>

	    case '/basket/checkout':
	      if (order.list.length === 0) {
	        return <div />
	      } else {
	        return (
	          <div className={checkoutFooterWrapStyle}>
	            {this.renderCheckoutFooter()}
	            {this.renderToast()}
	          </div>
	        )
	      }

	    case '/basket/history':
	      return null

	    default:
	      return (
	        <div className={commonFooterWrapStyle}>
	          {this.renderFooter()}
	          {this.renderToast()}
	        </div>
	      )
	  }
	};
}

export default injectSheet(styles)(FooterComponent)



// WEBPACK FOOTER //
// ./src/components/Footer.js